import http from 'axios';
import KeycloakService from './keycloak/keycloakService';
import router from '@/router';

// const apiURL = ;

const api = http.create({
    baseURL: '/api',
});


function getUserToken(): string {
    var token: string = "";
    const session = localStorage.getItem('token');
    
    const objUser = session && JSON.stringify(session);
    if (objUser) token = `Bearer ${objUser.replace(/['"]+/g, '')}`;
    else token = "no token";
    return token;
}

export function clearLocalStorage() {
    const cookiesKeycloak = [
        "KEYCLOAK_IDENTITY",
        "KEYCLOAK_IDENTITY_LEGACY",
        "KEYCLOAK_SESSION",
        "KEYCLOAK_SESSION_LEGACY",
      ];
    
      // Itera sobre os cookies do Keycloak e os remove um por um
    for (let i = 0; i < cookiesKeycloak.length; i++) {
        const cookieKeycloak = cookiesKeycloak[i];
        
        document.cookie = `${cookieKeycloak}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      }
    
      // Exibe uma mensagem ou executa qualquer outra ação necessária após a limpeza dos cookies do Keycloak
    console.log('Cookies do Keycloak limpos');
    delete api.defaults.headers.common['Authorization'];
    localStorage.clear();
}

api.interceptors.request.use(
    (request) => {
        request.headers.Authorization = getUserToken();
        request.headers["Access-Control-Allow-Origin"] = "*";
        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    function (response){
        const token = getUserToken();

        if (token != null){
            api.defaults.headers.common['Authorization'] = token;
        }
        return response;
    },
    function (error) {
        if(error.response.status === 401 || error.response.status === 403){
            const cause = error.response.data.cause as string;

            if(cause && cause.includes('io.jsonwebtoken.ExpiredJwtException')){
            }
            KeycloakService.CallLogout("/");
            clearLocalStorage();
        }

        return Promise.reject(error);
        
    }
);

export function getRoles(){
    const roles = JSON.parse(localStorage.getItem('userInfo') || '{}').roles;
    return roles[0];
}
export default api;